import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { SearchedFile } from '@classes/wiki/searched-file.model';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SearchedService } from '@services/wiki/searched.service';
import { UtilitiyService } from '@services/wiki/utility.service';
import { DirectoryModel } from '@classes/wiki/directory-model.model';
import { environment } from '@environments/environment';
import { TextToFind } from '@classes/wiki/text-to-find.model';
import { Subscription } from 'rxjs';
import { FileService } from '@services/wiki/file.service';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  private textSub: Subscription;
  private providerSub: Subscription;

  private provider: string = null;

  searchResult: SearchedFile[];
  wordSearched: string;
  dataSource: MatTableDataSource<SearchedFile>;
  tableColumns: string [] = ['row'];
  isLoading = false;

  constructor(
    private router: Router,
    private searchedService: SearchedService,
    private utilityService: UtilitiyService,
    private fileService: FileService) {
    }


  ngOnInit() {
    this.initPage();
  }

  loadEditor(file: DirectoryModel): void {
    const strippedPath = file.path.substring(file.path.lastIndexOf('\\') + 1);
    const encryptedPath = this.utilityService.encryptString(strippedPath);
    this.router.navigate([`/wiki/file/${encryptedPath}`]);
  }

  stripHtml(html: string) {
    return this.utilityService.stripHtml(html);
  }

  private initPage(): void {
    this.dataSource = new MatTableDataSource<SearchedFile>();

    this.providerSub = (this.fileService.getProviderSub().subscribe(provider => {
      this.provider = provider;
      const word = sessionStorage.getItem(environment.wordSearched);
      if (word) {
        const ttf = JSON.parse(sessionStorage.getItem(environment.wordSearched));
        this.searchForWord(ttf);
        this.wordSearched = ttf.text;
      }
      this.textSub = this.searchedService.getTextToFindSub().subscribe(data => {
        this.searchForWord(data);
        this.wordSearched = data.text;
      });
    }));
  }

  private searchForWord(ttf: TextToFind): void {
    this.isLoading = true;
    this.searchedService.findFiles(ttf, this.provider).subscribe(data => {
      this.isLoading = false;
      this.searchResult = data;
      this.dataSource.data = this.searchResult;
      this.dataSource.paginator = this.paginator;
    });
  }
  ngOnDestroy(): void {
    if (this.textSub) {
      this.textSub.unsubscribe();
    }
    if (this.providerSub) {
      this.providerSub.unsubscribe();
    }
  }

}
